import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';
import UserProfileBubble from '../../UserProfileBubble/UserProfileBubble';
import { CommentOwner } from '../types';
import { getTimeUnitFromEpochMs } from '../../../util/timestampFormatting';
import { TimeUnit } from '../../../util/timeUnit';

interface CommentBoxUserNameProps {
  commentOwner?: CommentOwner;
  authorUserId: string;
  createdAt: string;
}

const CommentBoxUserName = ({
  commentOwner,
  authorUserId,
  createdAt,
}: CommentBoxUserNameProps) => {
  const timeUnit = getTimeUnitFromEpochMs(createdAt);
  const isTimestampLabelJustNow = timeUnit.type === TimeUnit.Now;

  const { classes } = useStyles({
    shortenNameMaxWidth: isTimestampLabelJustNow,
  });

  return (
    <div className={classes.container}>
      <UserProfileBubble
        userId={commentOwner?.id ?? authorUserId}
        userInitials={commentOwner?.initials}
        size="sm"
        tooltipText={commentOwner?.name ?? 'Deactivated user'}
      />
      <Typography
        variant="pSm"
        bold
        className={commentOwner ? classes.name : classes.noWrap}
      >
        {commentOwner?.name ?? 'Deactivated user'}
      </Typography>
    </div>
  );
};

const useStyles = makeStyles<{ shortenNameMaxWidth: boolean }>()(
  (theme, { shortenNameMaxWidth }) => ({
    container: {
      display: 'flex',
      gap: theme.spacing(1.5),
      alignItems: 'center',
    },
    name: {
      maxWidth: shortenNameMaxWidth ? 75 : 100,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    noWrap: {
      whiteSpace: 'nowrap',
    },
  })
);

export default CommentBoxUserName;
